import { render, staticRenderFns } from "./CargoTracking.vue?vue&type=template&id=13641c18&scoped=true&"
import script from "./CargoTracking.vue?vue&type=script&lang=js&"
export * from "./CargoTracking.vue?vue&type=script&lang=js&"
import style0 from "./CargoTracking.vue?vue&type=style&index=0&id=13641c18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13641c18",
  null
  
)

export default component.exports